import smsService from '../../services/sms-service'


const state = {
    loading: false,
    errors: null,
    balance:0,
    recipients:[]
}

const actions = {
    getBalance({ commit },data) {
        commit('SMS_BALANCE',0)
        commit('SMS_LOADING', true)
        commit('SMS_FAILURE', null)
        if(data){
           
            smsService.getBalance(data).then(
                response => {
                    commit('SMS_BALANCE',response.data)
                    commit('SMS_LOADING', false)
                },
                error => {
                    commit('SMS_FAILURE', error)
                    commit('SMS_LOADING', false)
                }
            )
        }else{
            //alert("no request api key found")
        }

    },
    send({ commit }, data) {
        commit('SMS_LOADING', true)
        commit('SMS_FAILURE', null)
        smsService.send(data).then(
            response => {
               // console.log(response)

                commit('SMS_LOADING', false)

            },
            error => {
                commit('SMS_FAILURE', error)
                commit('SMS_LOADING', false)
            }
        )
    },
  

}

const mutations = {
   
    SMS_BALANCE(state, payload) {
        state.balance=payload;
    },
    SMS_FAILURE(state, payload) {
        state.errors = payload
    },

    SMS_LOADING(state, payload) {
        state.loading = payload
    },
}


const getters = {
    SMS_BALANCE: state => {
        return state.balance
    },

    SMS_RCPTS: state => {
        return state.recipients
    },

    SMS_ERROR: state => {
        return state.errors
    },

    SMS_LOADING: state => {
        return state.loading
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}